export default __webpack_public_path__ + "static/media/mars2.ac508e59.gif";